import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DateInputComponent } from '../date-input/date-input.component';

@Component({
    selector: 'date-field',
    templateUrl: './date-field.component.html',
    styleUrls: ['./date-field.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: DateFieldComponent,
            multi: true
        }],
    imports: [NgClass, TooltipModule, DateInputComponent]
})

export class DateFieldComponent implements ControlValueAccessor {
    _value: Date;

    @Input() label: string;
    @Input() minDate: Date;
    @Input() maxDate: Date;
    @Input() disabled = false;
    @Input() required = false;
    @Input() labelSize = 6;

    @Output() valueChange = new EventEmitter<Date>();

    @Input()
    set value(value: Date) {
        if (this._value === value) {
            return;
        }

        this._value = value;
        this.valueChange.emit(value);
    }
    get value(): Date {
        return this._value;
    }

    @ViewChild("dateInput", { static: true }) dateInput: DateInputComponent;

    writeValue(obj: Date): void {
        this.value = obj;
        this.dateInput.writeValue(obj);
    }
    registerOnChange(fn: any): void {
        this.dateInput.registerOnChange(fn);
    }
    registerOnTouched(fn: any): void {
        this.dateInput.registerOnTouched(fn);
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}